export default __webpack_public_path__ + "static/media/Work Visa - Type.355b8d27.jpg";